<template>
    <v-container fluid grid-list-xl>
        <v-layout row justify-start>
            <v-flex d-block>
                <div class="nav">
                    <router-link :to="{name: 'caseCreationOrders'}">{{
                        $t('updateCaseCreationOrder.links.backToCaseCreationOrders')}}
                    </router-link>
                </div>
                <v-card>
                    <v-card-title>
                        <h3 v-t="'updateCaseCreationOrder.title'"></h3>
                    </v-card-title>
                    <v-card-text>
                        <v-layout>
                            <v-flex xs12 md7 lg5>
                                <div class="declineReason"
                                     v-if="updateCaseCreationOrder.data && updateCaseCreationOrder.data.declineReason">
                                    <v-alert
                                            :value="true"
                                            type="error"
                                    >
                                        {{ updateCaseCreationOrder.data.declineReason }}
                                    </v-alert>
                                </div>
                            </v-flex>
                        </v-layout>
                        <case-creation-order-form v-if="updateCaseCreationOrder.form.data"
                                           class="mb-4"
                                           ref="updateCaseCreationOrderForm"
                                           :valid="updateCaseCreationOrder.form.valid"
                                           context="updateCaseCreationOrder"
                                           :errorMessages="updateCaseCreationOrder.form.errorMessages"
                                           :readOnly="readOnly"
                                           :materialsCreationFormState="updateCaseCreationOrder.materialsFormValue"
                                           :caseCreationOrder="updateCaseCreationOrder.form.data"
                                           :currentClient="currentClient"
                                           :servicesByClients="servicesByClients"
                                           :availableServicesById="availableServicesById"
                                           :checkMaterialExistsFunc="checkMaterialExists"
                                           @createMaterial="ccofCreateMaterial" @deleteMaterial="ccofDeleteMaterial"
                                           @addService="ccofAddService" @removeService="ccofRemoveService"
                                           @changeServiceQuantity="ccofChangeServiceQuantity"
                                           @updateFiles="ccofUpdateFiles" @updateFormField="ccofUpdateFormField"
                                           @changeFormValid="handleChangeFormValid"
                        ></case-creation-order-form>
                    </v-card-text>
                </v-card>
                <v-bottom-sheet inset persistent hide-overlay full-width :value="true">
                    <v-layout row class="case-creation-order-control-menu">
                        <v-flex>
                            <v-card>
                                <v-card-text>
                                    <div class="status"><span>{{ $t('updateCaseCreationOrder.status')}}: </span><b>{{ status }}</b></div>
                                    <v-btn
                                            v-if="uccoCanCreate"
                                            :disabled="!updateCaseCreationOrder.form.valid || orderProgress"
                                            :loading="orderProgressByAction('update')"
                                            color="success"
                                            @click="handleSendToDiagnosticsClick"
                                            v-t="'updateCaseCreationOrder.buttons.toDiagnostics.label'"
                                    ></v-btn>
                                    <v-btn
                                            v-if="uccoCanUpdateAfterCreation"
                                            :disabled="!updateCaseCreationOrder.form.valid || orderProgress"
                                            :loading="orderProgressByAction('update')"
                                            color="success"
                                            @click="handleUpdateButtonClick"
                                            v-t="'updateCaseCreationOrder.buttons.update.label'"
                                    ></v-btn>
                                    <v-btn
                                            v-if="uccoCanSendToValidation"
                                            :disabled="!updateCaseCreationOrder.form.valid || orderProgress"
                                            :loading="orderProgressByAction('update')"
                                            color="success"
                                            @click="handleSendToValidationButtonClick"
                                            v-t="'updateCaseCreationOrder.buttons.toValidation.label'"
                                    ></v-btn>
                                    <v-menu v-model="declineMenuVisible"
                                            v-if="canDecline"
                                            absolute
                                            offset-y
                                            min-width="400"
                                            :close-on-content-click="false"
                                            :close-on-click="false"
                                    >
                                        <v-btn
                                                slot="activator"
                                                :disabled="orderProgress"
                                                :loading="orderProgressByAction('decline')"
                                                @click="handleDeclineMenuButtonClick"
                                                v-t="'updateCaseCreationOrder.buttons.decline.label'"
                                        ></v-btn>

                                        <v-card>
                                            <v-card-title>{{ $t('updateCaseCreationOrder.decline.title') }}
                                            </v-card-title>
                                            <v-card-text>
                                                <v-form ref="declineForm" v-model="declineFormValid">
                                                    <v-textarea v-model="declineReason"
                                                                outline
                                                                :counter="2000"
                                                                :rules="declineReasonValidationRules"
                                                    ></v-textarea>
                                                    <v-btn :disabled="!declineFormValid || orderProgress"
                                                           :loading="orderProgressByAction('decline')"
                                                           color="primary"
                                                           v-t="'updateCaseCreationOrder.decline.buttons.ok.label'"
                                                           @click="handleDeclineButtonClick"></v-btn>
                                                    <v-btn v-t="'updateCaseCreationOrder.decline.buttons.cancel.label'"
                                                           @click="handleDeclineCancelButtonClick"></v-btn>
                                                </v-form>
                                            </v-card-text>
                                        </v-card>
                                    </v-menu>
                                    <v-btn
                                            v-if="canCancel"
                                            :disabled="!updateCaseCreationOrder.form.valid || orderProgress"
                                            :loading="orderProgressByAction('cancel')"
                                            @click="handleCancelButtonClick"
                                            v-t="'updateCaseCreationOrder.buttons.cancel.label'"
                                    ></v-btn>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>

                </v-bottom-sheet>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

  import _ from 'lodash'
  import {CCOF_CHANGE_FORM_VALID} from '../../store/mutations/available'
  import CaseCreationOrderForm from './CaseCreationOrderForm'
  import {hasRole} from '../../helpers/user'
  import {mapActions, mapGetters, mapState} from 'vuex'

  export default {
    name: 'update-case-creation-order',
    components: {
      CaseCreationOrderForm
    },
    created() {
      const orderId = _.get(this.$route.params, 'id', null)

      if (!orderId) {
        console.log('Unable to get orderId')
        return
      }

      this.fillUpdatedCaseOrder(parseInt(orderId))
    },
    data() {
      return {
        bottomNav: null,
        declineMenuVisible: false,
        declineFormValid: null,
        declineReason: null,
        declineReasonValidationRules: [
          v => !!v || this.$t('updateCaseCreationOrder.decline.errors.required'),
          v => (v && v.length <= 2000) || this.$t('updateCaseCreationOrder.decline.errors.length')
        ],
      }
    },
    computed: {
      ...mapState({
        user: state => state.user,
        caseCreationOrders: state => state.caseCreationOrders,
        availableUsersById: state => state.availableUsersById,
        updateCaseCreationOrder: state => state.updateCaseCreationOrder,
        currentClient: state => state.currentClient,
        servicesByClients: state => state.servicesByClients,
        availableServicesById: state => state.availableServicesById,
        availableCaseCreationOrderStatusesByValue: state => state.availableCaseCreationOrderStatusesByValue,
      }),
      ...mapGetters({
        uccoCanCreate: 'uccoCanCreate',
        uccoCanUpdateAfterCreation: 'uccoCanUpdateAfterCreation',
        uccoCanSendToValidation: 'uccoCanSendToValidation'
      }),
      readOnly() {
        const status = _.get(this.updateCaseCreationOrder, 'data.status', null)

        const caseStatus = _.get(this.updateCaseCreationOrder, 'data.caseStatus', null)

        if (caseStatus !== null && caseStatus === 'waitingForMaterials') {
          return false
        }

        const isAdmin = hasRole(this.user, 'admin') || hasRole(this.user, 'clientadmin')

        if (isAdmin) {
          return _.includes(['completed', 'processing', 'canceled', 'sendingToDiagnostics', 'diagnostics'], status)
        }

        return _.includes(['completed', 'processing', 'canceled', 'validation', 'sendingToDiagnostics', 'diagnostics'], status)
      },
      status() {
        const status = _.get(this.updateCaseCreationOrder, 'data.status', null)

        if (!status) {
          return '-'
        }

        return _.get(this.availableCaseCreationOrderStatusesByValue, [status, 'title'], '-')
      },
      canDecline() {
        const status = _.get(this.updateCaseCreationOrder, 'data.status', null)

        return (hasRole(this.user, 'admin') || hasRole(this.user, 'clientadmin')) && status === 'validation'
      },
      canCancel() {
        const status = _.get(this.updateCaseCreationOrder, 'data.status', null)

        return (hasRole(this.user, 'admin') || hasRole(this.user, 'clientadmin')) && !_.includes(['processing', 'completed', 'canceled', 'sendingToDiagnostics', 'diagnostics', 'waitingForMaterials'], status)
      },
      orderProgress() {
        const orderId = _.get(this.updateCaseCreationOrder, 'data.id', null)

        if (!orderId) {
          return false
        }

        return _.get(this.caseCreationOrders, ['progressByOrders', orderId, 'progress'], false)
      }
    },
    watch: {
      '$route'(to) {
        const orderId = _.get(to.params, 'id', null)

        if (!orderId) {
          console.log('Unable to get orderId')
          return
        }

        this.fillUpdatedCaseOrder(parseInt(orderId))
      }
    },
    methods: {
      ...mapActions({
        fillUpdatedCaseOrder: 'fillUpdatedCaseOrder',
        ccofUpdateFormField: 'ccofUpdateFormField',
        ccofAddService: 'ccofAddService',
        ccofRemoveService: 'ccofRemoveService',
        ccofChangeServiceQuantity: 'ccofChangeServiceQuantity',
        ccofCreateMaterial: 'ccofCreateMaterial',
        ccofDeleteMaterial: 'ccofDeleteMaterial',
        ccofResetForm: 'ccofResetForm',
        ccofUpdateFiles: 'ccofUpdateFiles',
        caseCreationOrdersCancel: 'caseCreationOrdersCancel',
        caseCreationOrdersDecline: 'caseCreationOrdersDecline',
        caseCreationOrdersUpdate: 'caseCreationOrdersUpdate',
        checkMaterialExistsFunc: 'checkMaterialExists'
      }),
      orderProgressByAction(action) {
        const orderId = _.get(this.updateCaseCreationOrder, 'data.id', null)

        if (!orderId) {
          return false
        }

        return _.get(this.caseCreationOrders, ['progressByOrders', orderId, action], false)
      },
      handleChangeFormValid(value) {
        this.$store.commit(CCOF_CHANGE_FORM_VALID, value)
      },
      handleSendToDiagnosticsClick() {
        if (!this.$refs['updateCaseCreationOrderForm'].validate()) {
          return
        }

        this.caseCreationOrdersUpdate({vue: this, immediateCreation: true})
      },
      handleUpdateButtonClick() {
        if (!this.$refs['updateCaseCreationOrderForm'].validate()) {
          return
        }

        this.caseCreationOrdersUpdate({vue: this, immediateCreation: true})
      },
      handleSendToValidationButtonClick() {
        if (!this.$refs['updateCaseCreationOrderForm'].validate()) {
          return
        }

        this.caseCreationOrdersUpdate({vue: this, immediateValidation: true})
      },
      handleDeclineMenuButtonClick() {
        this.declineMenuVisible = true
      },
      handleCancelButtonClick() {
        const userId = _.get(this.updateCaseCreationOrder, 'data.userId', null)
        const user = _.get(this.availableUsersById, userId, null)

        let confirmationMessage = this.$t('updateCaseCreationOrder.messages.cancelConfirmation') + '?'

        if (user) {
          confirmationMessage = `${this.$t('updateCaseCreationOrder.messages.cancelConfirmation')} ${user.name}?`
        }

        if (!confirm(confirmationMessage)) {
          return
        }

        const orderId = _.get(this.updateCaseCreationOrder, 'data.id', null)

        if (!orderId) {
          return false
        }

        this.caseCreationOrdersCancel({vue: this, orderId: orderId})
      },
      async handleDeclineButtonClick() {
        if (!this.$refs['declineForm'].validate()) {
          return
        }

        const orderId = _.get(this.updateCaseCreationOrder, 'data.id', null)

        if (!orderId) {
          return false
        }

        await this.caseCreationOrdersDecline({
          vue: this,
          orderId: orderId,
          reason: this.declineReason
        })
      },
      handleDeclineCancelButtonClick() {
        this.declineMenuVisible = false
        this.resetDeclineForm()
      },
      resetDeclineForm() {
        this.$refs['declineForm'].reset()
        this.declineReason = null
      },
      checkMaterialExists (code) {
        const caseId = _.get(this.updateCaseCreationOrder, ['data', 'caseId'], null)
        return this.checkMaterialExistsFunc({
          code: code,
          caseId: caseId
        })
      }
    },
  }
</script>

<style scoped>
    .status {
        margin: 0 10px 0 10px;
        font-size: 15px;
        display: inline-block;
    }

    .nav {
        margin-bottom: 10px;
    }

</style>

<style>
    .case-creation-order-control-menu .v-card__text {
        padding: 5px;
    }

</style>